import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { tap } from 'rxjs/operators';
import { aomSubmittedAction } from '@contracting/modals';

import { choosePropositionAction } from '../../bac/10.proposition';

@Injectable()
export class AOMModalEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly store$: Store<any>
  ) {}

  public readonly aomSubmitted$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(aomSubmittedAction),
        tap((action) => {
          const { offer } = action;

          this.store$.dispatch(choosePropositionAction({ offer }));
        })
      ),
    { dispatch: false }
  );
}
